module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAGlJREFUKM9jKGUgDBkGjyKF0gNAjFeRYumD0lelOvgUQZTo4rNOsfRh6WuYEoQiPtxKYIpsS9+WukKFlNCVwBQJl14o/QZWBlGihz0IIMqSsSlBdjhI2f/SN5hKUH0nXLoHm5JBFcFwCAAt6K1585s0AgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/checked.png
// module id = 40
// module chunks = 0